export const WhatIsSlim = `Enabling "Slim" removes non-essential properties like IDs, versions, and timestamps from the displayed JSON/YAML. This simplifies the configuration to show only what's necessary for applying the resource.`;
